/**
 * İletişim: kendi arayüzünüzden Google Form yanıtlarına gönderim.
 * Google "formResponse" uç noktası; tarayıcıda gizli iframe + POST (CORS yok).
 *
 * entry.XXXXX değerlerini bulma:
 * Formu düzenle → sağ üst ⋮ veya "Gönder" → "Ön doldurulmuş bağlantı al" (Get pre-filled link)
 * Açılan URL’de &entry.1234567890= gibi parametreler görünür; her alan bir entry.
 * İsim sırası: formlan Ad, E-posta, Konu, Mesaj (Google’daki alan sıranızla aynı olmalı).
 *
 * Tercihen .env (üretimde gizli tutulabilir):
 * REACT_APP_GOOGLE_FORM_ID, REACT_APP_GF_ENTRY_NAME, _EMAIL, _SUBJECT, _MESSAGE
 */
/**
 * Yalnızca "doldurulabilir form" linkindeki id — URL şekli:
 * https://docs.google.com/forms/d/e/BURASI/viewform
 * Düzenleme ekranındaki /d/11VW2v.../edit gibi kısa belge id'leri /d/e/.../formResponse ile 404 verir.
 */
const PUBLISHED_E_FORM_ID =
  "1FAIpQLSe_YYOJsMeStHayk1J-UDc3PdSCKjcs6FOOTqbQ_H5HSsMxcw";

function isValidPublishedFormEid(id) {
  if (!id || id.length < 20) return false;
  // Google Forms yayındaki e-id genelde 1FAIpQLS ile başlar; 11VW2v... gibi değerler bu uçta geçersizdir.
  return /^1FAIpQLS[0-9A-Za-z_-]+$/i.test(id);
}

function resolveFormId(fromEnv) {
  const s = str(fromEnv);
  if (s && isValidPublishedFormEid(s)) return s;
  return PUBLISHED_E_FORM_ID;
}

/**
 * Sitenizdeki 4 alanın Google’daki "entry" anahtarları. Ön doldurulmuş bağlantıdaki
 * sıraya göre: Ad, E-posta, Konu, Kısa cevap / Uzun paragraf. Boş bırakılırsa .env dener.
 */
const FALLBACK_ENTRIES = {
  name: "entry.1383614831",
  email: "entry.926981700",
  subject: "entry.1267571210",
  message: "entry.2096054525",
};

function str(v) {
  if (v == null) return "";
  return String(v)
    .replace(/^\uFEFF/, "")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .replace(/^['"]|['"]$/g, "")
    .trim();
}

export function getGoogleFormContactConfig() {
  const fromEnvId =
    typeof process !== "undefined" ? process.env.REACT_APP_GOOGLE_FORM_ID : "";

  const formId = resolveFormId(fromEnvId);

  const name =
    str(
      typeof process !== "undefined"
        ? process.env.REACT_APP_GF_ENTRY_NAME
        : ""
    ) || str(FALLBACK_ENTRIES.name);
  const email =
    str(
      typeof process !== "undefined" ? process.env.REACT_APP_GF_ENTRY_EMAIL : ""
    ) || str(FALLBACK_ENTRIES.email);
  const subject =
    str(
      typeof process !== "undefined" ? process.env.REACT_APP_GF_ENTRY_SUBJECT : ""
    ) || str(FALLBACK_ENTRIES.subject);
  const message =
    str(
      typeof process !== "undefined" ? process.env.REACT_APP_GF_ENTRY_MESSAGE : ""
    ) || str(FALLBACK_ENTRIES.message);

  const entries = { name, email, subject, message };
  const isReady = Object.values(entries).every(
    (e) => /^entry\.\d+$/i.test(e)
  );

  const actionUrl = `https://docs.google.com/forms/d/e/${formId}/formResponse`;

  return { formId, actionUrl, entries, isReady };
}

/** Gizli iframe hedefi: document içinde aynı name ile <iframe> olmalı. */
export const GOOGLE_FORM_HIDDEN_IFRAME_NAME = "pm_google_form_contact";

/**
 * @param {Record<'name'|'email'|'subject'|'message', string>} values
 * @param {{ name: string, email: string, subject: string, message: string }} entryKeys
 */
export function postGoogleFormInHiddenIframe(actionUrl, entryKeys, values) {
  const form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("action", actionUrl);
  form.setAttribute("target", GOOGLE_FORM_HIDDEN_IFRAME_NAME);
  form.setAttribute("accept-charset", "UTF-8");
  form.style.display = "none";
  for (const key of ["name", "email", "subject", "message"]) {
    const en = entryKeys[key];
    if (!en) continue;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = en;
    input.value = values[key] ?? "";
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
  window.setTimeout(() => {
    if (form.parentNode) form.parentNode.removeChild(form);
  }, 2000);
}
